import { Component, ElementRef, EventEmitter, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Consultation } from 'src/app/utils/interfaces/new/consultation.interface';
import { environment } from 'src/environments/environment';

interface SelectListObject {
  id: string;
  libelle: string;
}

@Component({
  selector: 'app-select-consultation',
  templateUrl: './select-consultation.component.html',
  styleUrls: [
    './select-consultation.component.scss',
    '../../../../../../../fragments/modal/modal.fragment.scss'
  ]
})
export class SelectConsultationComponent implements OnInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  public closeEmitter = new EventEmitter();
  public consultations: Array<Consultation> = [];
  public consultationsListValues: Array<SelectListObject> = [];
  public formGroup: FormGroup;

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeModal();
    }
  }

  constructor(
    private _formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    for (const c of this.consultations) {
      this.consultationsListValues.push({
        id: c.id,
        libelle: c.titre
      });
    }

    this.formGroup = this._formBuilder.group({
      title: [undefined, Validators.required]
    });
  }

  public validForm(): void {
    const selected = this.formGroup.get('title').value;
    this.closeModal(selected && selected !== '' ? selected : undefined);
  }

  public closeModal(selectedConsultationId?: string): void {
    this.closeEmitter.emit(selectedConsultationId);
  }

}
